// Hjelparar for Butikk-modulen (status, prisformat, lenker). Berre UI-logikk – ingen omsetjing av arrangørinnhald.
import { tr } from "./i18n";

export function nok(amount) {
  const v = Math.round(Number(amount || 0));
  return `${v.toLocaleString("nb-NO")} kr`;
}

export function shopUrl(organizerId) {
  return `/butikk/${organizerId}`;
}

export function productUrl(organizerId, productId) {
  return `/butikk/${organizerId}/vare/${productId}`;
}

export function orderUrl(orderId) {
  return `/butikk/ordre/${orderId}`;
}

export function checkoutUrl(organizerId) {
  return `/butikk/${organizerId}/kasse`;
}

// Betalingsstatus for ordre → etikett + tokenbaserte klassar (design: info/secondary/success/danger)
export function orderStatusMeta(order) {
  const s = order?.status;
  if (s === "pending_payment" || s === "processing") return { label: tr("Venter på Vipps"), className: "bg-[hsl(var(--info))] text-[hsl(var(--info-foreground))] hover:bg-[hsl(var(--info))]", key: "pending" };
  if (s === "invoice_sent") return { label: tr("Faktura sendt"), className: "bg-secondary text-secondary-foreground border border-border hover:bg-secondary", key: "invoice_sent" };
  if (s === "paid") return { label: tr("Betalt"), className: "bg-[hsl(var(--success))] text-[hsl(var(--success-foreground))] hover:bg-[hsl(var(--success))]", key: "paid" };
  if (s === "cancelled") return { label: tr("Kansellert"), className: "bg-[hsl(var(--danger))] text-[hsl(var(--danger-foreground))] hover:bg-[hsl(var(--danger))]", key: "cancelled" };
  if (s === "refunded" || s === "refunding") return { label: tr("Refundert"), className: "bg-[hsl(var(--danger))] text-[hsl(var(--danger-foreground))] hover:bg-[hsl(var(--danger))]", key: "refunded" };
  return { label: s || "", className: "bg-secondary text-secondary-foreground", key: s || "" };
}

export function fulfillmentMeta(order) {
  const f = order?.fulfillment;
  if (f === "ready") return { label: tr("Klar for henting"), className: "bg-[hsl(var(--info))] text-[hsl(var(--info-foreground))] hover:bg-[hsl(var(--info))]" };
  if (f === "shipped") return { label: tr("Sendt"), className: "bg-[hsl(var(--success))] text-[hsl(var(--success-foreground))] hover:bg-[hsl(var(--success))]" };
  if (f === "picked_up") return { label: tr("Hentet"), className: "bg-[hsl(var(--success))] text-[hsl(var(--success-foreground))] hover:bg-[hsl(var(--success))]" };
  return { label: tr("Ikke behandlet"), className: "bg-secondary text-secondary-foreground border border-border hover:bg-secondary" };
}

export function stockMeta(product) {
  const st = product?.stock_status;
  if (st === "sold_out") return { label: tr("Utsolgt"), className: "bg-[hsl(var(--danger))] text-[hsl(var(--danger-foreground))] hover:bg-[hsl(var(--danger))]" };
  if (st === "low") return { label: product?.remaining != null ? tr("{n} igjen", { n: product.remaining }) : tr("Få igjen"), className: "bg-[hsl(var(--warning))] text-[hsl(var(--warning-foreground))] hover:bg-[hsl(var(--warning))]" };
  return null;
}

export function isInvoiceOverdue(order) {
  return order?.status === "invoice_sent" && order?.invoice_due_at && new Date(order.invoice_due_at) < new Date();
}

export function deliveryLabel(order) {
  return order?.delivery_method === "shipping" ? tr("Sending i posten") : tr("Henting hos arrangøren");
}

export function paymentLabel(order) {
  if (order?.payment_method === "invoice") return tr("Faktura");
  if (order?.payment_method === "free") return tr("Gratis");
  return tr("Vipps");
}

export function addressLine(address) {
  if (!address) return "";
  return [address.line1, [address.postal_code, address.city].filter(Boolean).join(" ")].filter(Boolean).join(", ");
}
